export default class BrowserStorage {
  constructor(browserStorage = window.localStorage, storageKey = 'appStorage') {
    try {
      // Older browsers and Mobile Safari Private browsing will fail
      browserStorage.setItem('foo', 'bar');
      browserStorage.removeItem('foo');
      this.storageSupported = true;
    } catch (e) {
      this.storageSupported = false;
    }
    this.browserStorage = browserStorage;
    this.storageKey = storageKey;
    const data = this.storageSupported
      ? this.browserStorage.getItem(this.storageKey)
      : null;
    this.cache = data ? JSON.parse(data) : {};
  }

  get(key) {
    return this.cache[key];
  }

  all() {
    return this.cache;
  }

  has(key) {
    return typeof this.get(key) !== 'undefined';
  }

  set(key, value) {
    this.cache[key] = value;
    this.persist();
  }

  push(key, value) {
    if (Array.isArray(this.cache[key])) {
      this.cache[key] = [...this.cache[key], value];
    } else {
      this.cache[key] = [value];
    }
    this.persist();
  }

  pull(key) {
    const data = this.get(key);
    this.forget(key);
    return data;
  }

  forget(key) {
    delete this.cache[key];
    this.persist();
  }

  flush() {
    this.cache = {};
    this.persist();
  }

  persist() {
    if (this.storageSupported) {
      this.browserStorage.setItem(this.storageKey, JSON.stringify(this.cache));
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/browser-storage.js